import type { LearnBrandOverrides } from './types'

/**
 * Brand-NEUTRAL machinery. Nothing here may name a brand.
 *
 * This file used to BE AI Coding Patterns while `brands/acp.ts` was empty, so a
 * fork setting VITE_BRAND_ID to an unregistered id got `{}` merged over ACP and
 * silently shipped ACP's name, palette and footer. Identity lives in
 * `brands/<id>.ts` now; the palette below is a deliberately drab grey so a brand
 * that has not chosen its colours looks unfinished rather than like someone else.
 */
export const defaults: LearnBrandOverrides = {
  // No neutral wordmark exists, so `assets.logo` is REQUIRED per brand rather
  // than defaulted — a missing one must fail loudly, not render someone else's.
  legal: null,
  monitoring: {
    sentryDsn: null,
    apiHost: null,
  },
  theme: {
    colors: {
      blue: '#5a6270',
      blueLight: '#8a8f98',
      blueSoft: '#eceef1',
      bluePress: '#4a515c',
      blueStrong: '#3c4',
      gold: '#7d7458',
      goldSoft: '#f1efe9',
      goldStrong: '#5f5943',
      purple: '#6f6a78',
      purpleSoft: '#eeedf0',
      purpleStrong: '#565160',
      green: '#5f6b60',
      greenSoft: '#ecefec',
      greenStrong: '#48524a',
      red: '#7a5c5c',
      redSoft: '#f2eaea',
      redStrong: '#5e4646',
      ink: '#1b1e24',
      inkSoft: '#4a4f58',
      inkFaint: '#767c86', // AA: #8a90a0 daba 3.19:1 sobre blanco (WCAG AA pide 4.5:1)
      bg: '#ffffff',
      bgSoft: '#f4f5f7',
      surface: '#ffffff',
      surfaceAlt: '#f7f8fa',
      line: '#e6e8ec',
      lineStrong: '#d3d6dc',
    },
    fonts: {
      // Consolidated 3-font system: Space Grotesk (logo + headings),
      // Hanken Grotesk (body/UI), Jersey 25 (pixel "HUD" accent — eyebrows
      // only). Jersey 15 lives ONLY in the blog landing (huge hero text);
      // learn has no hero, so `display` falls back to the heading face.
      heading: "system-ui, sans-serif",
      body: "system-ui, sans-serif",
      mono: "ui-monospace, SFMono-Regular, 'SF Mono', Menlo, monospace",
      display: "system-ui, sans-serif",
      eyebrow: "system-ui, sans-serif",
    },
    radii: {
      card: '16px',
      button: '12px',
    },
    googleFontsUrl: '',
  },
}
